import React from 'react';
/**
 * Custom hook to observe size changes in a resizable element.
 * @param observedElementRef - Ref (React.useRef) of an element to observe. The element must be in the DOM.
 * @param onResize - Callback function invoked when the observed element is resized. Receives a DOMRectReadOnly object
 * with size information and the element reference.
 * @example
 * const ref = useRef(null);
 * useResizeObserver(ref, (rect, element) => {
 *   console.log('Resized to:', rect.width, rect.height);
 * });
 */
export const useResizeObserver = (observedElementRef, onResize) => {
    const observerRef = React.useRef(null);
    React.useEffect(() => {
        const observer = new ResizeObserver((entries) => {
            if (entries.length && entries[0]) {
                onResize(entries[0].contentRect, entries[0].target);
            }
        });
        observerRef.current = observer;
        if (observedElementRef.current) {
            observer.observe(observedElementRef.current);
        }
        // Disconnect observer on cleanup to prevent memory leaks
        return () => observer.disconnect();
    }, [observedElementRef, onResize]);
};
